import init from '../../helpers/init';

const {$} = init;

$(() => {
  $('.js-register-form').on('submit', (e: JQuery.SubmitEvent) => {
    e.preventDefault();

    const isAgree = $('.js-agree-checkbox').is(':checked');

    if (!isAgree) {
      $('.js-consent-modal').modal('show');
      return false;
    }

    e.currentTarget.submit();
  });
});
